
import { Component, Vue } from 'vue-property-decorator';
// import { ruan_route } from '@/router/index';
import { namespace } from 'vuex-class';
const Hundun = namespace('Hundun');
const { VUE_APP_XDB: XDB } = process.env;
import storage from 'baimahu/storage';
import { ruan_menu, ruan_sub_menu, hundun_menu, hundun_sub_menu, limit_menu, limit_sub_menu } from '@/module/menu';
import moment from 'moment';

const _ = {
  intersectionBy: require('lodash/intersectionBy')
};

const { VUE_APP_FCAPI: fcapi } = process.env;

const API = {
  product_menu: `${fcapi}/boss/setting/auth/product/menu`,
  message_notify: `${fcapi}/boss/hundun/message/notify/0`
};

@Component
export default class Menu extends Vue {
  @Hundun.Action('FETCH_TAGS') getTags: any; //获取tag
  @Hundun.Action('FETCH_TEACHER') getTeacher: any; //获取教师
  XDB = XDB;
  menuList = ruan_sub_menu;
  user_info = storage.getItem('profile');
  menu = ruan_menu;
  async created() {
    await this.getMenuList();
    this.getMessageNotify();
  }
  async getMenuList() {
    if (this.$route.path.includes('hundun')) {
      const { data } = await this.$axios.get(`${API.product_menu}?product_code=hundun`);
      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      const rule_data = data.data.rule_list.map((item: any) => {
        return {
          id: item - 0
        };
      });
      const filter_menu_list = _.intersectionBy(data.data.menu_list, rule_data, 'id');
      console.log(filter_menu_list);
      console.log(data);

      const main_menu = filter_menu_list.filter((item: any) => item.type === 1);
      const sub_menu = filter_menu_list.filter((item: any) => item.type === 2);
      this.getTeacher();
      this.getTags();
      const sub_menu_data = JSON.parse(JSON.stringify(hundun_sub_menu));
      console.log(hundun_sub_menu);
      sub_menu_data.forEach((item: any) => {
        console.log(item.children);
        console.log(sub_menu);

        item.children = _.intersectionBy(item.children, sub_menu, 'name');
      });

      console.log(main_menu);
      console.log(sub_menu_data);
      console.log(hundun_menu);
      this.menuList = _.intersectionBy(sub_menu_data, main_menu, 'name');
      this.menu = _.intersectionBy(hundun_menu, main_menu, 'name');
      console.log(this.menuList);
      console.log(this.menu);
      // this.menuList = hundun_sub_menu;
      // this.menu = hundun_menu;
    }
    if (this.$route.path.includes('limit')) {
      const { data } = await this.$axios.get(`${API.product_menu}?product_code=auth`);
      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      const rule_data = data.data.rule_list.map((item: any) => {
        return {
          id: item | 0
        };
      });
      const filter_menu_list = _.intersectionBy(data.data.menu_list, rule_data, 'id');
      const sub_menu = filter_menu_list.filter((item: any) => item.type === 2);
      const main_menu = filter_menu_list.filter((item: any) => item.type === 1);
      this.menuList = _.intersectionBy(limit_sub_menu, sub_menu, 'name');
      this.menu = _.intersectionBy(limit_menu, sub_menu, 'name');
    }
    if (!this.menuList.length && !this.menu.length) {
      this.$message.error('没有权限操作');
    }
  }
  async getMessageNotify() {
    const { data } = await this.$axios.get(API.message_notify);
    const { VUE_APP_STAGE: stage } = process.env;
    this.menuList.forEach((item: any) => {
      if (item.name == '创商院') {
        item.children.forEach((element: any) => {
          if (element.name == '流量池') element.count = data.data.chuang_seeding_count;
          if (element.name == '报名列表') {
            if (['dev', 'local'].includes(stage as any)) element.count = data.data.chuang_recruiting_count;
            if (stage == 'test' && JSON.parse(localStorage[`${stage}:profile`])?.data.name == '雷媛媛')
              element.count = data.data.chuang_recruiting_count;
            if (stage == 'prod' && JSON.parse(localStorage[`${stage}:profile`])?.data.name == '王晓琼')
              element.count = data.data.chuang_recruiting_count;
          }
        });
      }
      if (item.name == '企业工作列表') {
        item.children.forEach((element: any) => {
          if (element.name == '企业回访列表') element.count = data.data.company_visit_count;
          if (element.name == '企业意向列表') element.count = data.data.company_intention_count;
        });
      }
    });
    this.$forceUpdate();
  }
  handleOutlogin(): void {
    storage.removeItem('profile');
    this.$router.push('/passport');
  }
  handleChooseMenu(item: any) {
    // console.log(item);
  }

  messageNotify(path: string) {
    // if (this.$route.path == path) return;
    this.$router.push({
      path: path,
      query: { time: Number(moment().unix()) as any, name: JSON.parse(localStorage[`${process.env.VUE_APP_STAGE}:profile`]).data.name }
    });
  }
  SelectedMenuItem(item: any) {
    // console.log('选中');
    // console.log(item);
  }
}
